import { Collapse } from '@hfzq/crab-react';
import React, { FC } from 'react';
import styles from './index.module.less';

interface ErrorModalContentProps {
  message: string;
  detailMessage: string;
}

export const ErrorModalContent: FC<ErrorModalContentProps> = ({ message, detailMessage }) => (
  <div className={styles.errorModalContent}>
    <div>{message}</div>
    {!!detailMessage && (
      <Collapse>
        <Collapse.Panel key="1" title="详情">
          {detailMessage}
        </Collapse.Panel>
      </Collapse>
    )}
  </div>
);
